import {
  Cpu, Database, Network, Crown, Bot, Globe2, ArrowUpRight,
} from "lucide-react";

const SERVICES = [
  {
    icon: Cpu,
    title: "IT Recruitment Europe",
    desc: "Full-stack, backend, frontend, mobile, DevOps across DE/NL/RO/PL/BG.",
    cols: "md:col-span-7",
    tone: "blue",
  },
  {
    icon: Database,
    title: "SAP Recruitment",
    desc: "S/4HANA, FICO, MM, SD, BTP, ABAP — across DACH and CEE.",
    cols: "md:col-span-5",
    tone: "slate",
  },
  {
    icon: Network,
    title: "Nearshore Software Engineers",
    desc: "Romania, Poland, Bulgaria — vetted teams, EU timezone, EU contracts.",
    cols: "md:col-span-5",
    tone: "teal",
  },
  {
    icon: Crown,
    title: "Executive Search Europe",
    desc: "C-level, VP & Director tech leadership in 14+ European markets.",
    cols: "md:col-span-7",
    tone: "amber",
  },
  {
    icon: Bot,
    title: "AI Engineers Europe",
    desc: "ML, LLM, MLOps, Applied AI — including senior research roles.",
    cols: "md:col-span-6",
    tone: "blue",
  },
  {
    icon: Globe2,
    title: "Remote Developers Europe",
    desc: "Distributed senior engineers across 20+ EU/EEA countries.",
    cols: "md:col-span-6",
    tone: "slate",
  },
];

const TONE = {
  blue: "bg-blue-50 text-blue-700",
  slate: "bg-slate-100 text-slate-700",
  teal: "bg-teal-50 text-teal-700",
  amber: "bg-amber-50 text-amber-700",
};

export default function Services() {
  return (
    <section
      id="services"
      data-testid="services-section"
      className="py-20 lg:py-28"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-2xl">
          <div className="text-xs uppercase tracking-[0.2em] text-slate-500 font-semibold">
            Services
          </div>
          <h2 className="font-display font-bold mt-3 text-3xl sm:text-4xl lg:text-5xl tracking-tight text-slate-900">
            One agency. Every European tech hiring need.
          </h2>
          <p className="mt-4 text-slate-600">
            From individual senior hires to fully-managed nearshore squads —
            backed by AI matching and a senior recruiter for every account.
          </p>
        </div>

        <div className="mt-12 grid grid-cols-1 md:grid-cols-12 gap-6">
          {SERVICES.map((s, i) => {
            const Icon = s.icon;
            return (
              <div
                key={s.title}
                data-testid={`service-card-${i}`}
                className={`group ${s.cols} rounded-2xl border border-slate-200 bg-white p-6 sm:p-8 hover:-translate-y-1 hover:shadow-lg transition-all duration-300 flex flex-col justify-between min-h-[200px]`}
              >
                <div>
                  <div
                    className={`w-11 h-11 rounded-xl grid place-items-center ${TONE[s.tone]}`}
                  >
                    <Icon className="w-5 h-5" strokeWidth={1.5} />
                  </div>
                  <h3 className="font-display font-bold text-xl sm:text-2xl text-slate-900 mt-5">
                    {s.title}
                  </h3>
                  <p className="mt-3 text-slate-600 leading-relaxed">{s.desc}</p>
                </div>
                <div className="mt-6 text-sm text-slate-500 inline-flex items-center gap-1 group-hover:text-blue-700">
                  Learn more <ArrowUpRight className="w-4 h-4" />
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
